import React from 'react';
import { P2GBox } from '@parcel2go/peacock-legacy-core/dist/box';
import { P2GCdnImage } from '@parcel2go/peacock-legacy-core/dist/image';
import { P2GProgress } from '@parcel2go/peacock-legacy-core/dist/progress';

export interface LoadingProps {
  variant?: 'DEFAULT' | 'APP';
}

export default function Loading(props: LoadingProps) {
  if (props.variant === 'APP') {
    return (
      <P2GBox textAlign="center">
        <P2GCdnImage alt="Loading" style={{ width: '100px', height: '100px' }} src="/app/app-loading.gif" />
      </P2GBox>
    );
  }

  return (
    <P2GBox textAlign="center">
      <P2GProgress />
    </P2GBox>
  );
}
